import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import humanTime from 'flarum/common/helpers/humanTime';
export default class MyVotesView extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "expandUnvoted", true);
    _defineProperty(this, "removingVotes", new Set());
  }
  getVotesInfo(award) {
    const categories = award.categories() || [];
    const currentUserId = app.session.user?.id();
    const userVotes = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      return !vUserId || String(vUserId) === String(currentUserId);
    });
    const votesLimit = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10);
    const votedCategories = [];
    const unvoted = [];
    let lastVoteTime = null;
    let totalVotes = 0;
    categories.forEach(category => {
      const categoryId = category.id();
      const nominees = category.nominees() || [];

      // Find ALL votes for this category (multi-vote support)
      const categoryVotes = userVotes.filter(v => {
        const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
        return String(vCategoryId) === String(categoryId);
      });
      if (categoryVotes.length > 0) {
        const voteEntries = [];
        categoryVotes.forEach(vote => {
          const vNomineeId = vote.nomineeId?.() || vote.data?.relationships?.nominee?.data?.id;
          const nominee = nominees.find(n => String(n.id()) === String(vNomineeId));
          if (nominee) {
            voteEntries.push({
              nominee,
              vote
            });
            totalVotes++;

            // Track last vote time
            const voteTime = vote.createdAt?.();
            if (voteTime && (!lastVoteTime || voteTime > lastVoteTime)) {
              lastVoteTime = voteTime;
            }
          }
        });
        if (voteEntries.length > 0) {
          // Can add more if: unlimited (0) OR below limit
          const canAddMore = votesLimit === 0 || voteEntries.length < votesLimit;
          votedCategories.push({
            category,
            votes: voteEntries,
            votesLimit,
            canAddMore
          });
        }
      } else {
        unvoted.push(category);
      }
    });
    return {
      votedCategories,
      unvoted,
      lastVoteTime,
      totalVotes
    };
  }
  removeVote(vote, nominee) {
    const voteId = String(vote.id());
    if (this.removingVotes.has(voteId)) return;
    this.removingVotes.add(voteId);
    m.redraw();
    vote.delete().then(() => {
      // Decrement vote count for the nominee
      const currentVoteCount = nominee.voteCount?.() || 0;
      if (currentVoteCount > 0) {
        nominee.pushData({
          attributes: {
            voteCount: currentVoteCount - 1
          }
        });
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('huseyinfiliz-awards.forum.voting.vote_removed'));
      this.removingVotes.delete(voteId);
      m.redraw();
    }).catch(e => {
      this.removingVotes.delete(voteId);
      m.redraw();
      throw e;
    });
  }
  view() {
    const award = this.attrs.award;
    const onNavigateToCategory = this.attrs.onNavigateToCategory;
    const categories = award.categories() || [];
    const isVotingOpen = award.isVotingOpen();
    const {
      votedCategories,
      unvoted,
      lastVoteTime,
      totalVotes
    } = this.getVotesInfo(award);
    const totalCategories = categories.length;
    const votedCategoryCount = votedCategories.length;
    return m("div", {
      className: "MyVotesView"
    }, m("div", {
      className: "MyVotesView-summary"
    }, m("div", {
      className: "MyVotesView-summary-content"
    }, m("div", {
      className: "MyVotesView-summary-stats"
    }, m("span", {
      className: "MyVotesView-summary-count"
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.summary', {
      voted: votedCategoryCount,
      total: totalCategories
    })), m("span", {
      className: "MyVotesView-summary-totalVotes"
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.total_votes', {
      count: totalVotes
    })), lastVoteTime ? m("span", {
      className: "MyVotesView-summary-time"
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.last_vote', {
      time: humanTime(lastVoteTime)
    })) : null), m("div", {
      className: "MyVotesView-summary-progress"
    }, m("div", {
      className: "MyVotesView-summary-progressBar",
      style: {
        width: `${totalCategories > 0 ? votedCategoryCount / totalCategories * 100 : 0}%`
      }
    })))), votedCategories.length > 0 ? m("div", {
      className: "MyVotesView-section"
    }, m("h3", {
      className: "MyVotesView-section-title"
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.title')), m("div", {
      className: "MyVotesView-list"
    }, votedCategories.map(_ref => {
      let {
        category,
        votes,
        votesLimit,
        canAddMore
      } = _ref;
      return m("div", {
        className: "MyVotesView-categoryGroup",
        key: category.id()
      }, m("div", {
        className: "MyVotesView-categoryHeader"
      }, m("span", {
        className: "MyVotesView-categoryName"
      }, category.name()), m("span", {
        className: "MyVotesView-categoryVoteCount"
      }, votesLimit === 0 ? app.translator.trans('huseyinfiliz-awards.forum.my_votes.votes_unlimited', {
        count: votes.length
      }) : app.translator.trans('huseyinfiliz-awards.forum.my_votes.votes_used', {
        used: votes.length,
        limit: votesLimit
      }))), votes.map(_ref2 => {
        let {
          nominee,
          vote
        } = _ref2;
        return m("div", {
          className: "MyVotesView-item",
          key: vote.id()
        }, m("div", {
          className: "MyVotesView-item-nominee"
        }, nominee.imageUrl() ? m("img", {
          className: "MyVotesView-item-image",
          src: nominee.imageUrl(),
          alt: nominee.name()
        }) : m("div", {
          className: "MyVotesView-item-placeholder"
        }, m("i", {
          className: "fas fa-user"
        }))), m("div", {
          className: "MyVotesView-item-info"
        }, m("div", {
          className: "MyVotesView-item-name"
        }, nominee.name())), m("div", {
          className: "MyVotesView-item-meta"
        }, vote.createdAt?.() ? m("span", {
          className: "MyVotesView-item-date"
        }, humanTime(vote.createdAt())) : null), m("div", {
          className: "MyVotesView-item-actions"
        }, isVotingOpen ? m(Button, {
          className: "Button Button--text Button--danger",
          onclick: () => this.removeVote(vote, nominee),
          loading: this.removingVotes.has(String(vote.id()))
        }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.remove')) : null));
      }), isVotingOpen && canAddMore ? m("div", {
        className: "MyVotesView-addMore"
      }, m(Button, {
        className: "Button Button--text",
        icon: "fas fa-plus",
        onclick: () => onNavigateToCategory(String(category.id()))
      }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.add_vote'))) : null);
    }))) : m("div", {
      className: "MyVotesView-empty"
    }, m("i", {
      className: "fas fa-vote-yea"
    }), m("p", null, app.translator.trans('huseyinfiliz-awards.forum.my_votes.no_votes'))), unvoted.length > 0 ? m("div", {
      className: "MyVotesView-section MyVotesView-section--unvoted"
    }, m("button", {
      className: "MyVotesView-section-header",
      onclick: () => {
        this.expandUnvoted = !this.expandUnvoted;
        m.redraw();
      }
    }, m("h3", {
      className: "MyVotesView-section-title"
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.categories_remaining'), m("span", {
      className: "MyVotesView-section-count"
    }, "(", unvoted.length, ")")), m("i", {
      className: `fas fa-chevron-${this.expandUnvoted ? 'up' : 'down'}`
    })), this.expandUnvoted ? m("div", {
      className: "MyVotesView-unvotedList"
    }, unvoted.map(category => m("div", {
      className: "MyVotesView-unvotedItem",
      key: category.id()
    }, m("span", {
      className: "MyVotesView-unvotedItem-name"
    }, category.name()), m(Button, {
      className: "Button Button--primary Button--small",
      onclick: () => onNavigateToCategory(String(category.id()))
    }, app.translator.trans('huseyinfiliz-awards.forum.my_votes.vote_now'))))) : null) : null);
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/MyVotesView', MyVotesView);